import request from '@/utils/request'

export async function getData(data) {
    return request({
        url: '/statistics/approvalRecord/carApplication',
        method: 'post',
        data,
    })
}